export default __webpack_public_path__ + "static/media/why_us_bg.b79058df.jpg";